import { CreateStepTemplateRequestSchema, CreateStepTemplateResponseSchema } from './create-step-template.schema';
/**
 * Create Step Template Endpoint Contract
 * Snapshots the selected draft nodes into a tenant-wide Schrittvorlage
 */ export const createStepTemplateContract = {
    method: 'POST',
    path: '/api/v2/process/:processId/draft/step-templates',
    description: 'Save the selected draft nodes as a step template',
    requestSchema: CreateStepTemplateRequestSchema,
    responseSchema: CreateStepTemplateResponseSchema,
    statusCodes: {
        success: 201,
        errors: {
            400: 'Bad Request - a requested node is not a step or event of this draft',
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden',
            404: 'Draft not found'
        }
    }
};

//# sourceMappingURL=create-step-template.contract.js.map